import axios from "axios";
import { API_URL } from "@/config";

const staffHttp = axios.create({ baseURL: API_URL, withCredentials: true });

export interface StaffUser {
    staff_id: number;
    first_name: string;
    last_name: string;
    email: string;
    role: string;
    dealer_id: number | null;
    shop_id: number | null;
}

export const STAFF_ROLE_DASHBOARD: Record<string, string> = {
    service_advisor: "/service/dashboard",
    service_manager: "/service/dashboard",
    service_tech:    "/technician/dashboard",
    parts_clerk:     "/parts/dashboard",
    parts_manager:   "/parts/dashboard",
    insurance:       "/insurance/dashboard",
    transport:       "/transport/dashboard",
    warranty:        "/warranty/dashboard",
    collision:       "/collision/dashboard",
    salvage:         "/salvage/dashboard",
    backoffice:      "/admin/dashboard",
    auction_staff:   "/auction/dashboard",
};

export async function loginStaff(
    email: string,
    password: string
): Promise<{ ok: boolean; staff?: StaffUser; redirect?: string; message?: string }> {
    const res = await staffHttp.post("/staff/auth/login", { email, password });
    return res.data;
}

export async function logoutStaff(): Promise<void> {
    await staffHttp.post("/staff/auth/logout");
}

export async function getCurrentStaff(): Promise<{ ok: boolean; staff?: StaffUser }> {
    const res = await staffHttp.get("/staff/auth/me");
    return res.data;
}
